// extracted by mini-css-extract-plugin
export default {"volumeButton":"VolumeButton_volumeButton__TzEz4"};